import { render } from "./StudentOwnChallengesView.vue?vue&type=template&id=7e8feb6d"
import script from "./StudentOwnChallengesView.vue?vue&type=script&lang=js"
export * from "./StudentOwnChallengesView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dashboard.epsasport-dev.apps.lu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__